<template>
  <div>
    <SelectExistingDocument
      v-if="showExistingDocuments"
      :replacement="replacement"
      @attach="attachExistingDocuments"
      @back="backToNewDocument"
    />

    <!-- Using v-show instead of v-else because there are events attached to DOM by the caller -->
    <div v-show="!showExistingDocuments">
      <div v-if="showFileManageArea" class="sf-pad-b-3">
        <div
          class="sf-grid sf-grid-fluid sf-pad-l-3 sf-pad-r-3 sf-pad-t-3"
          data-behaviour="document-select-file-collection-container"
        >
          <div class="sf-row.sf-row-center">
            <div class="sf-col sf-xs-12 sf-pad-l-0 sf-pad-r-0">
              <div class="sf-tab">
                <div data-behaviour="document-select-file-collection" />
                <div data-behaviour="document-select-in-progress-uploads" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <multi-file-direct-uploader
        v-if="!disabled"
        :existing-files="files"
        :accept="accept"
        :on-file-uploaded="onFileUploaded"
        :on-file-removed="onFileRemoved"
        :on-file-upload-progress="onFileUploadProgress"
      >
        <DocumentsUploaderText
          :variant="variant"
          @select-existing="selectExistingFileClick"
        >
          <template #post-script>
            <slot name="post-script" />
          </template>
        </DocumentsUploaderText>
      </multi-file-direct-uploader>
      <DocumentsUploaderText v-else :variant="variant" :disabled="true">
        <template #post-script>
          <slot name="post-script" />
        </template>
      </DocumentsUploaderText>

      <div v-if="showControls" class="sf-grid sf-pad-3">
        <div class="sf-row sf-row-center">
          <div class=".sf-col.sf-xs-12">
            <div class="sf-level sf-level-center">
              <div
                class="sf-btn"
                data-behaviour="document-select-file-collection-download"
                style="display: none"
              >
                {{ I18n.t('common.download_all') }}
              </div>
              <div
                v-if="!replacement"
                data-behaviour="document-select-file-collection-save-container document-select-hide-when-locked"
              >
                <div
                  class="sf-btn sf-btn-success"
                  data-behaviour="document-select-file-collection-save"
                >
                  {{ I18n.t('common.save') }}
                </div>
                <div
                  class="sf-btn sf-btn-success sf-btn-disabled"
                  data-behaviour="document-select-file-collection-save-disabled"
                  style="display: none"
                >
                  {{ I18n.t('common.save') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DocumentsUploaderText from './documents-uploader-text.vue'
import MultiFileDirectUploader from '@app/shared/vue/components/direct-upload/multi-file-direct-uploader'
import SelectExistingDocument from '@app/application/reconciliation/sections/select-existing-document'

export default {
  name: 'DocumentsUploader',

  components: {
    DocumentsUploaderText,
    MultiFileDirectUploader,
    SelectExistingDocument,
  },

  props: {
    accept: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    replacement: {
      type: Boolean,
      required: false,
      default: false,
    },
    onFileUploaded: {
      type: Function,
      required: false,
      default: () => {},
    },
    onFileRemoved: {
      type: Function,
      required: false,
      default: () => {},
    },
    onFileAttached: {
      type: Function,
      required: false,
      default: () => {},
    },
    onFileUploadProgress: {
      type: Function,
      required: false,
      default: () => {},
    },
    showControls: {
      type: Boolean,
      required: false,
      default: true,
    },
    showFileManageArea: {
      type: Boolean,
      required: false,
      default: true,
    },
    variant: {
      type: String,
      required: false,
      default: 'default',
    },
  },

  emits: ['select-existing-toggle'],

  data: function () {
    return {
      files: this.files || {},
      showExistingDocuments: this.showExistingDocuments || false,
    }
  },

  methods: {
    selectExistingFileClick() {
      this.showExistingDocuments = true
      this.$emit('select-existing-toggle', true)
    },
    backToNewDocument() {
      this.showExistingDocuments = false
      this.$emit('select-existing-toggle', false)
    },
    attachExistingDocuments(entries) {
      if (this.disabled) {
        return
      }

      this.onFileAttached(entries)
      this.showExistingDocuments = false
      this.$emit('select-existing-toggle', false)
    },
  },
}
</script>
